import React, { useState } from 'react';
import { Spin, Descriptions, Image, Button, Modal, message } from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import { useDispatch } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { ShopifyChannelDesciption } from '../../../constants/marketPlace';
import { salesChannelManagement } from '../../../redux/actions/marketPlaceAction';
import { CONNECTION_DELETE_SUCCESS } from '../../../constants/messages';

const { confirm } = Modal;

const ShopifyDetails = (props) => {
  const { channel, shopifyDetails, selectedCompany, toggleViewDrawer } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const deleteShopifyConnection = (id) => {
    setLoading(true);
    dispatch(
      salesChannelManagement('delete.connection', {
        company_id: get(selectedCompany, 'id'),
        id,
      })
    )
      .then(() => {
        setLoading(false);
        message.success(CONNECTION_DELETE_SUCCESS);
        toggleViewDrawer();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onconfirmDelete = (id) => {
    confirm({
      title: 'Are you sure!',
      icon: <ExclamationCircleFilled />,
      content: 'Do you want to delete this connection?',
      onOk() {
        deleteShopifyConnection(id);
      },
      onCancel() {},
    });
  };

  return (
    <Spin spinning={loading}>
      <div className="mt-10 text-center">
        <Image src={get(channel, 'image')} width={130} />
      </div>
      <div className="product-final-confirmation-container mt-40">
        <Descriptions bordered column={1} size="small">
          {map(ShopifyChannelDesciption, (description) => (
            <Descriptions.Item
              key={get(description, 'id')}
              label={get(description, 'title')}
            >
              {get(shopifyDetails, get(description, 'key'))
                ? get(shopifyDetails, get(description, 'key'))
                : '--'}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>

      <div className="mt-30">
        <Button
          className="default-btn"
          onClick={() => {
            onconfirmDelete(get(channel, 'Connection.id'));
          }}
        >
          Delete
        </Button>
      </div>
    </Spin>
  );
};

export default ShopifyDetails;
